<template>
    <div class="py-4 lg:py-6 px-3 lg:px-6">
      <h1 class="text-green-500 text-3xl font-semibold">Customers</h1>
      <customer-table></customer-table>
    </div>
  </template>
  
  <script>
  import CustomerTable from '@/components/CustomerTable.vue'
  export default {
    components: { CustomerTable },
    mounted(){
      
    }
  }
  </script>
  
  <style>
  
  </style>